/**
 * View component for /user-nodes/:userNodeId/update
 *
 * Updates a single userNode from a copy of the selcted userNode
 * as defined in the userNode reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as userNodeActions from '../userNodeActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import module components
import UserNodeForm from '../components/UserNodeForm.js.jsx';
import UserNodeLayout from '../components/UserNodeLayout.js.jsx';

// import userNode css modules
import userNodeStyles from '../userNodeModuleStyles.css';

class UpdateUserNode extends Base {
  constructor(props) {
    super(props);
    const { selectedUserNode, userNodeMap } = this.props;
    this.state = {
      userNode: userNodeMap[selectedUserNode.id] ? { ...userNodeMap[selectedUserNode.id] } : {}
      // NOTE: we don't want to change the store, just make changes to a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(userNodeActions.fetchSingleIfNeeded(match.params.userNodeId))
  }

  componentWillReceiveProps(nextProps) {
    const { selectedUserNode, userNodeMap } = nextProps;
    this.setState({
      userNode: userNodeMap[selectedUserNode.id] ? { ...userNodeMap[selectedUserNode.id] } : {}
      //we don't want to actually change the store's userNode, just use a copy
    })
  }

  _handleFormChange(e) {
    let newUserNodeState = _.update( this.state.userNode, e.target.name, function() {
      return e.target.value;
    });
    this.setState({userNode :newUserNodeState});
  }

  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(userNodeActions.sendUpdateUserNode(this.state.userNode)).then((action) => {
      if(action.success) {
        history.push(`/user-nodes/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { selectedUserNode, userNodeMap } = this.props;
    const { userNode } = this.state;
    const isEmpty = (!userNode || userNode._id === null || userNode._id === undefined);
    return  (
      <UserNodeLayout>
        <div className="flex">
          <section className="section">
            {isEmpty ?
              (selectedUserNode.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
              :
              <UserNodeForm
                userNode={userNode}
                cancelLink={`/user-nodes/${userNode._id}`}
                formTitle="Update User Node"
                formType="update"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
              />
            }
          </section>
        </div>
      </UserNodeLayout>
    )
  }
}

UpdateUserNode.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    selectedUserNode: store.userNode.selected
    , userNodeMap: store.userNode.byId
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(UpdateUserNode)
);



// WEBPACK FOOTER //
// modules/userNode/views/UpdateUserNode.js.jsx